import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import AlertaVerde from "./components/AlertaVerde/AlertaVerde";
import AlertaRoja from "./components/AlertaRoja/AlertaRoja";
import AlertaAzul from "./components/AlertaAzul/AlertaAzul";
import AlertaAmarilla from "./components/AlertaAmarilla/AlertaAmarilla";
import AlertaEntity from "../../core/entities/alertaEntity";

const AlertaFlotante = forwardRef(({}, ref) => {
  const [vPosicion, setVPosicion] = useState("105");
  const [isActivo, setIsActivo] = useState(false);
  const [alerta, setalerta] = useState(new AlertaEntity());
  var timer = null;

  const [vKeyAlerta, setvKeyAlerta] = useState(Date.now());

  /**
   * Exposición de métodos para controlar la notificación desde un componente padre.
   */
  useImperativeHandle(ref, () => ({
    /**
     * Muestra una nueva notificación.
     *
     * @param {AlertaEntity} neAlerta - Objeto de notificación a mostrar.
     */
    show(neAlerta) {
      setvKeyAlerta(Date.now());
      if (isActivo) {
        handleCerrar(false);
        setTimeout(() => {
          setalerta(neAlerta);
          handleMostrar();
        }, 250);
      } else {
        setalerta(neAlerta);
        handleMostrar();
      }
    },
    /**
     * Oculta la notificación actual.
     */
    hide() {
      handleCerrar();
    },
  }));

  /**
   * Controla la animación de entrada/salida de la notificación según su estado activo.
   */
  useEffect(() => {
    isActivo ? setVPosicion("0") : setVPosicion("105");
  }, [isActivo]);

  /**
   * Gestiona el temporizador para ocultar la notificación después de un tiempo.
   */
  useEffect(() => {
    clearTimeout(timer);
    if (isActivo && alerta.duracion > 0) {
      timer = setTimeout(() => {
        handleCerrar();
      }, alerta.duracion * 1000);
      return () => clearTimeout(timer); // Limpia el temporizador cuando el componente se desmonte
    }
  }, [vKeyAlerta, alerta.duracion]);

  /**
   * Muestra la notificación activando el estado correspondiente.
   */
  const handleMostrar = () => {
    setIsActivo(true);
    setVPosicion("0");
  };

  /**
   * Cierra la notificación y opcionalmente la elimina.
   *
   * @param {boolean} isEliminar - Indica si se debe eliminar la notificación tras cerrar.
   */
  const handleCerrar = (isEliminar = true) => {
    if (isEliminar) {
      setTimeout(() => {
        setIsActivo(false);
      }, 250);
    }
    setVPosicion("105");
  };

  /**
   * Selecciona el componente de alerta según el tipo de alerta.
   */
  const AlertaSeleccionada = {
    verde: (
      <AlertaVerde
        titulo={alerta.titulo}
        descripcion={alerta.descripcion}
        handleCerrar={handleCerrar}
        tiempo={alerta.duracion}
        key={vKeyAlerta}
      />
    ),
    rojo: (
      <AlertaRoja
        titulo={alerta.titulo}
        descripcion={alerta.descripcion}
        handleCerrar={handleCerrar}
        tiempo={alerta.duracion}
        key={vKeyAlerta}
      />
    ),
    amarillo: (
      <AlertaAmarilla
        titulo={alerta.titulo}
        descripcion={alerta.descripcion}
        handleCerrar={handleCerrar}
        tiempo={alerta.duracion}
        key={vKeyAlerta}
      />
    ),
    azul: (
      <AlertaAzul
        titulo={alerta.titulo}
        descripcion={alerta.descripcion}
        handleCerrar={handleCerrar}
        tiempo={alerta.duracion}
        mostarBotones={alerta.mostarBotones}
        isBotonAceptar={alerta.isBotonAceptar}
        isBotonCancelar={alerta.isBotonCancelar}
        textoBotonAceptar={alerta.textoBotonAceptar}
        textoBotonCancelar={alerta.textoBotonCancelar}
        handleAceptar={() => {
          alerta.handleAceptar();
          handleCerrar();
        }}
        handleCancelar={() => {
          alerta.handleCancelar();
          handleCerrar();
        }}
        key={vKeyAlerta}
      />
    ),
  };
  return (
    <div
      class="box-alertas-v2"
      style={{ transform: `translate(${vPosicion}%, 0px)` }}
    >
      {isActivo && AlertaSeleccionada[alerta.tipo]}
    </div>
  );
});

export default AlertaFlotante;
